import React, { useState,useMemo } from "react";
import { Dialog, DialogContent, TextField } from "@mui/material";
import { Stack, Button, Box, Typography, styled } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { itemNewDesign } from "../features/ItemNewDesign";
import {Checkbox, Container, FormControl,FormControlLabel,InputLabel,Select,MenuItem } from "@mui/material";

const Input = styled("div")({
  border: "1px solid #4daf51",
  height: "60px",
  padding: "7px",
  borderRadius: "10px",
  boxShadow: "0px 3px 7px #4daf51",
});
const CardBox = styled(Box)({
  border: "1px solid grey",
  borderRadius: "4px",
  padding: "10px 5px",
});

function ShowBatchNos({ onClose, items, onSuccess }) {
  const [batchNums, setBatchNums] = useState(items || []);
  const [selected, setSelected] = useState("");
  const [selectedIdx, setSelectedIdx] = useState(null);
  const [modal, setModal] = useState(false);
  const [state, setState] = useState({
    batchNumber: "",
    expiryDate: "",
    quantity: "",
    box: false,
    piecesPerBox: 0,
    pricePerPiece:0,
    // saleLabel: false,
    newItem: {
      saleLabel: "",
      costPrice: "",
      price: "",
      companyPrice: 0,
      whole_sale_price:""
    },
  });
  console.log('batchNums', batchNums);
  console.log('selectedIndx', selectedIdx);
  console.log('stateeeee', state);
  console.log('seletcedd', selected);



  const toggle = (item = "", idx = null) => {
    console.log('itemmmmm', item)
    setModal((prev) => !prev);
    setSelected(item);
    setSelectedIdx(idx);
  };

  const priceCalculator= useMemo(() => {
    let costPrices = batchNums[selectedIdx]?.newItem?.costPrice;
    const salePrices = batchNums[selectedIdx]?.newItem?.price;
    const piecesPerBox = batchNums[selectedIdx]?.piecesPerBox;
   console.log('batchhhh', costPrices)
    return {
      costPrice: costPrices || [],
      salePrice: salePrices || [],
      piecesPerBox: piecesPerBox || []
    };
  }, [batchNums,selectedIdx]);
  console.log('priceee', priceCalculator.costPrice)
  const pricePerBoxHandler  = useMemo(() => {
    const pricePerBox = Number(state.newItem.price ||  priceCalculator.salePrice) / Number(state.piecesPerBox ||priceCalculator.piecesPerBox);
    console.log("priceperbox", pricePerBox);
    setState((prev) => ({ ...prev,pricePerPiece: pricePerBox}));
     setSelected((prev) => ({ ...prev, pricePerPiece: pricePerBox }));
    return pricePerBox;
  }, [state.newItem.price, state.piecesPerBox,batchNums,selectedIdx]);

  const handleInput = (e, i) => {
    const { name, value } = e.target;
  console.log('namee', name)
  console.log('value', value)

    if (
      name === "batchNumber" || 
      name === "expiryDate" || 
      name === "quantity" || 
      name === "box" || 
      name === "piecesPerBox"      ) {

        if(name == "quantity" || name == "piecesPerBox") {
          setState((prev) => ({ ...prev, [name]: Number(value) }));
          setSelected((prev) => ({ ...prev, [name]: Number(value) }));

        } else {
          setState((prev) => ({ ...prev, [name]: value }));
          setSelected((prev) => ({ ...prev, [name]: value }));

        }
  
    } else if(   
      name === "costPrice" || 
      name === "price" || 
      name === "companyPrice" || 
      name === "whole_sale_price" || 
      name === "saleLabel"
    ) {
      if(name == "costPrice" || name == "price") {
        setState((pre) => ({
          ...pre,
          newItem: { ...pre.newItem, [name]: Number(value) },
        }));

        setSelected((pre) => ({
          ...pre,
          newItem: { ...pre.newItem, [name]: Number(value) },
        }));

      } else {
        setState((pre) => ({
          ...pre,
          newItem: { ...pre.newItem, [name]: value },
        }));

        setSelected((pre) => ({
          ...pre,
          newItem: { ...pre.newItem, [name]: value },
        }));
      }
    
    }
    // setSelected((prev) => ({ ...prev, [name]: value }));
  };
  const updateRecord = () => {
    let copy = JSON.parse(JSON.stringify(batchNums));
    console.log('copyyy', copy)
    console.log('state', state)
    console.log('selected', selected)
    copy[selectedIdx] = selected;
    setBatchNums(copy);
    toggle();
  };
  const handleUpdate = () => {
    onSuccess(batchNums);
  };

  const handleBox = (e) => {
    let name = e.target.name;
    let value;
    if (name == "box" || name == "createFastCash") {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }
    setState((pre) => ({ ...pre, [name]: value }));
  };
  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        <Stack spacing={3}>
          <Stack direction="row" width="100%" justifyContent="space-between">
            <Typography variant="h6">Batch Numbers</Typography>
            <HighlightOffIcon onClick={onClose} sx={{ cursor: "pointer" }} />
          </Stack>
          {batchNums.length == 0 && (
            <Stack width="100%" justifyContent="center">
              <Typography sx={{ textAlign: "center" }}>
                No Batch Numbers{" "}
              </Typography>
            </Stack>
          )}

          {batchNums.map((item, i) => {
            return (
              <CardBox key={i}>
                <Stack>
                  <Stack
                    direction="row"
                    width="100%"
                    justifyContent="space-between"
                  >
                    <Typography>Batch No. {item.batchNumber}</Typography>
                    <Typography>Quantity {item.quantity}</Typography>
                  </Stack>
                  <Typography>Expiry Date {item.expiryDate}</Typography>
                </Stack>

                <Box>
                  <Button
                    size="small"
                    variant="outlined"
                    sx={{ textTransform: "none" }}
                    onClick={() => toggle(item, i)}
                  >
                    Edit
                  </Button>
                </Box>
              </CardBox>
            );
          })}
          {batchNums.length > 0 && (
            <Box>
              <Button
                variant="contained"
                size="small"
                sx={{ textTransform: "none" }}
                onClick={handleUpdate}
              >
                Updat
              </Button>
            </Box>
          )}
        </Stack>
      </DialogContent>

      <Dialog open={modal} fullWidth maxWidth="xs">
        <DialogContent>
          <Stack spacing={3}>
            <Stack direction="row" width="100%" justifyContent="space-between">
              <Typography variant="h6">Update Batch Number</Typography>
              <HighlightOffIcon onClick={toggle} sx={{ cursor: "pointer" }} />
            </Stack>

            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  columnGap: 5,
                }}
              >
                <TextField
                  fullWidth
                  size="small"
                  name="batchNumber"
                  label="Batch Number"
                  variant="outlined"
                  value={selected?.batchNumber || ""}
                  onChange={handleInput}
                />

                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  name="quantity"
                  label="Quantity"
                  variant="outlined"
                  value={selected?.quantity || ""}
                  onChange={handleInput}
                />
              </Box>
              <Box>
                <Typography sx={{ textAlign: "left" }}>Expiry Date</Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  name="expiryDate"
                  variant="outlined"
                  value={selected?.expiryDate || ""}
                  onChange={handleInput}
                />
              </Box>
            </Box>
             


            {!itemNewDesign() && (
          <Stack alignItems="flex-end">
            <FormControlLabel
              control={
                // <Checkbox checked={state.box } name="box" onChange={handleBox} />
                <Checkbox checked={state.box } name="box" onChange={handleBox} />

              }
              label="Ctn"
            />
          </Stack>
        )}
        {!itemNewDesign() && (
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ gap: { md: "0px", xs: "5px" } }}
          >
            {
             
              <Input>
                <TextField
                  variant="standard"
                  name="costPrice"
                  label={
                    state.box
                      ? state.newItem.saleLabel === "box"
                        ? "Cost Price Per Box"
                        : "Cost Price Per Ctn"
                      : "Cost Price"
                  }
                  // value={state.newItem.costPrice ||  priceCalculator.costPrice}
                  value={selected?.newItem?.costPrice || ""}
                  type="Number"
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                  onChange={handleInput}
                />
              </Input>
            }

            <Input>
              <TextField
                variant="standard"
                value={selected?.newItem?.price || ""}
                name="price"
                label={
                  state.box
                    ? state.newItem.saleLabel === "box"
                      ? "Sale Price Per Box"
                      : "Sale Price Per Ctn"
                    : "Sale Price"
                }
                type="Number"
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
          </Stack>
        )}

{!itemNewDesign() && (
          <>
            {!state.box && (
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ gap: { md: "0px", xs: "5px" } }}
              >
                <Input>
                  <TextField
                    variant="standard"
                    name="companyPrice"
                    label="Company Price"
                    type="Number"
                    value={state.newItem.companyPrice}
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    onChange={handleInput}
                  />
                </Input>

                <Input>
                  <TextField
                    variant="standard"
                    min="1"
                    label="Whole Sale Price"
                    name="whole_sale_price"
                    value={state.newItem.whole_sale_price}
                    type="number"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    onChange={handleInput}
                  />
                </Input>
              </Stack>
            )}

{state.box == true && (
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ gap: { md: "0px", xs: "5px" } }}
              >
                <Input>
                  <TextField
                    variant="standard"
                    name="piecesPerBox"
                    label={
                      state.newItem.saleLabel === "box"
                        ? "Pieces Per Box"
                        : "Box Per Ctn"
                    }
                    value={state.piecesPerBox || priceCalculator.piecesPerBox}
                    type="Number"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    onChange={handleInput}
                  />
                </Input>
                <Input>
                  <TextField
                    variant="standard"
                    name="pricePerPiece"
                    label={
                      state.newItem.saleLabel === "box"
                        ? "Price Per Piece"
                        : "Price Per Box"
                    }
                    value={pricePerBoxHandler }
                    type="Number"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    // onChange={handleInput}
                    
                  />
                </Input>
              </Stack>
            )}
          </>
        )}
          {state.box == true && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Select Sale Label</InputLabel>
              <Select
                variant="standard"
                name="saleLabel"
                defaultValue=""
                onChange={handleInput}
                 value={state.newItem.saleLabel || batchNums[selectedIdx]?.newItem?.saleLabel}
              >
                <MenuItem value="ctn">Ctn</MenuItem>
                <MenuItem value="box">Box</MenuItem>
              </Select>
            </FormControl>
          </Input>
        )}




            <Stack
              mt={1}
              direction="row"
              width="100%"
              justifyContent="space-between"
            >
              <Button
                variant="outlined"
                size="small"
                sx={{ textTransform: "none" }}
                onClick={toggle}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{ textTransform: "none" }}
                onClick={updateRecord}
              >
                Update
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </Dialog>
  );
}

export default ShowBatchNos;
